<template>

  <div>
    <div class="mb-3">
      <div class="form-inline">
        <div
          class="form-group mr-2"
          style="max-width: 290px;">
          <label></label>
          <div>
            <date-time
              :value="value.start_at"
              @input="setDateTime"></date-time>
            <ValidateMessage :error="validateErrors.start_at" />
          </div>
        </div>
        <div class="form-group">
          <div>
            <select-duration
              :clearable="false"
              v-model="value.duration"
              style="width: 200px;"></select-duration>
              <ValidateMessage :error="validateErrors.duration" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="value.start_at">

      <div class="form-group row">
        <label for="inputPassword3" class="col-sm-3 col-form-label">{{ $t('Type') }}</label>
        <div class="col-sm-9">
          <select
            class="form-control"
            v-model="value.type">
            <option value="phone-interview">{{ $t('Phone interview') }}</option>
            <option value="video-interview">{{ $t('Video interview') }}</option>
            <option value="on-site">{{ $t('On site') }}</option>
          </select>
          <ValidateMessage :error="validateErrors.type" />
        </div>
      </div>

      <div
        v-if="value.type === 'on-site'"
        class="form-group row">
        <label class="col-sm-3 col-form-label"></label>
        <div class="col-sm-9">
          <input-autocomplete
            :placeholder="$t('Location')"
            v-model="value.location"
            :options="locations"
            :minLength="0">
            </input-autocomplete>
          <ValidateMessage :error="validateErrors.location" />
        </div>
      </div>

      <div
        v-if="value.type === 'video-interview'"
        class="form-group row">
        <label class="col-sm-3 col-form-label"></label>
        <div class="col-sm-9">
          <div class="form-check">
            <input
              id="has_meet_link"
              class="form-check-input"
              type="checkbox"
              v-model="value.has_meet_link"
              :disabled="!resourceAvailability.features.includes('video_meet')">
            <label
              for="has_meet_link"
              class="form-check-label"
              v-tooltip="!resourceAvailability.features.includes('video_meet') ? 'Faça upgrade do plano' : null">
              Adicionar link de vídeo
            </label>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-3 col-form-label">{{ $t('Participants') }} *</label>
        <div class="col-sm-9">
          <select-multiple-user
            v-model="value.assigned_users"></select-multiple-user>
          <ValidateMessage :error="validateErrors.assigned_users" />
          <div
            class="mt-1"
            v-if="!showGuests">
            <a
              href="javascript:void(0)"
              @click="showGuests = true">{{ $t('Add guests') }}</a>
          </div>
        </div>
      </div>

      <div
        v-if="showGuests"
        class="form-group row">
        <label class="col-sm-3 col-form-label">{{ $t('Guests') }}</label>
        <div class="col-sm-9">
          <selectize-multiple-email 
            v-model="value.participants" 
            :options="[]">
            </selectize-multiple-email>
          <ValidateMessage :error="validateErrors.participants" />
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-3 col-form-label">{{ $t('Note') }}</label>
        <div class="col-sm-9">
          <textarea-autosize
            :placeholder="$t('Note')"
            v-model="value.note"
            :min-height="30"
            :max-height="350"
            class="form-control">
            </textarea-autosize>
          <ValidateMessage :error="validateErrors.note" />
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-3 col-form-label">{{ $t('Evaluation') }}</label>
        <div class="col-sm-9">
          <SelectScoreform
            v-model="value.scoreform_id"
            :placeholder="$t('Scorecard')" />
          <ValidateMessage :error="validateErrors.scoreform_id" />
        </div>
      </div>

      <div class="form-group">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" v-model="value.participants_invite">
          <label class="form-check-label">
            {{ $t('Notify participants and guests') }}
          </label>
        </div>
        <ValidateMessage :error="validateErrors.participants_invite" />
      </div>

      <div v-if="candidate.email">
        <div class="form-group">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" v-model="value.candidate_invite">
            <label class="form-check-label">
              {{ $t('Notify candidate') }}
            </label>
          </div>
          <ValidateMessage :error="validateErrors.candidate_invite" />
        </div>

        <div class="form-group" v-if="value.candidate_invite">
          <div class="input-group">
            <input class="form-control" :placeholder="$t('Subject')" v-model="value.candidate_invite_subject">
            <div class="input-group-append">
              <templatemail-select
                @setTemplate="setTemplate">
                </templatemail-select>
            </div>
          </div>
          <ValidateMessage :error="validateErrors.candidate_invite_subject" />
          
          <textarea-editable v-model="value.candidate_invite_body"></textarea-editable>
          <ValidateMessage :error="validateErrors.candidate_invite_body" />
        </div>
      </div>

      <div v-if="!candidate.email">
        <p class="alert alert-warning">O candidato não possui e-mail</p>
      </div>
      
    </div>

    <div :class="{'box-loading': loading}">
      <button
        type="submit"
        class="btn btn-primary"
        @click="saveEvent(value)">
        {{ $t('Save') }}
        </button>
      <button
        v-if="value._id"
        type="submit"
        class="btn btn-light"
        @click="$emit('cancel')">
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>

</template>

<script>
import SelectizeMultipleEmail from '@/components/Fields/SelectizeMultipleEmail'
import DateTime from '@/components/Fields/DateTime'
import InputAutocomplete from '@/components/Fields/InputAutocomplete'
import TemplatemailSelect from '@/components/Parts/TemplatemailSelect'
import SelectDuration from '@/components/Fields/SelectDuration'
import moment from 'moment'
import SelectMultipleUser from '@/components/Fields/SelectMultipleUser'
import SelectScoreform from '@/components/Fields/SelectScoreform'

export default {
  name: 'CandidateEventForm',
  components: {
    SelectizeMultipleEmail,
    DateTime,
    InputAutocomplete,
    TemplatemailSelect,
    SelectDuration,
    SelectMultipleUser,
    SelectScoreform
  },
  props: [
    'initValue'
  ],
  data () {
    const value = this.defaultValues(this.initValue)
    return {
      validateErrors: false,
      loading: false,
      value: value,
      showGuests: value.participants && value.participants.length >= 1
    }
  },
  computed: {
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    },
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    },
    locations () {
      if (this.selectedJob) {
        return [
          [
            this.selectedJob.address,
            this.selectedJob.neighborhood,
            this.selectedJob.city,
            this.selectedJob.region,
            this.selectedJob.zipcode,
            this.selectedJob.country
          ].join(', ')
        ]
      } else {
        return []
      }
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        type: 'on-site',
        location: null,
        note: null,
        assigned_users: [
          this.$store.getters.getMe._id
        ],
        participants: [
          // {
          //   name: this.$store.getters.getMe.name,
          //   email: this.$store.getters.getMe.email
          // }
        ],
        start_at: null,
        duration: 30,
        participants_invite: true,
        candidate_invite: true,
        candidate_invite_subject: null,
        candidate_invite_body: null,
        has_meet_link: false
      }, values)
    },
    /*
    saveEvent
    */
    saveEvent (data) {
      if (data._id) this.updateEvent(data)
      else this.createEvent(data)
    },
    /*
    resetEvent
    */
    resetEvent () {
      this.value = this.defaultValues({})
      this.validateErrors = false
    },
    /*
    createEvent
    */
    createEvent (data) {
      this.loading = true

      data.candidate_id = this.candidate._id
      data.job_id = this.selectedJob._id

      return this.$store
      .dispatch('createEvent', data)
      .then((result) => {
        this.loading = false
        this.resetEvent()
        this.$emit('created', result)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateEvent
    */
    updateEvent (data) {
      this.loading = true

      return this.$store
      .dispatch('updateEvent', data)
      .then((result) => {
        this.loading = false
        this.$emit('updated', result)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    setTemplate
    */
    setTemplate (template) {
      this.$set(this.value, 'candidate_invite_subject', template.subject)
      this.$set(this.value, 'candidate_invite_body', template.body)
    },
    /*
    setDateTime
    */
    setDateTime (value) {
      if (value && !this.value.start_at) {
        value = moment(value).set({ hour: 8 }).startOf('hour').toISOString()
      }
      this.value.start_at = value
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Event/CandidateEventForm.vue